// Import modules
import { initContactFormLabels } from './modules/contact-form-labels.js';
import initHeadroom from './modules/headroom-init.js';
import { initSliders } from './modules/slider.js';
import { initSideNav } from './modules/side-nav.js';
import { initSidebarPullUp } from './modules/sidebar-pull-up.js';
import { initMegaMenu } from './modules/mega-menu.js';
import { initMobileMenu } from './modules/mobile-menu.js';
import { initPostFilters } from './modules/post-filter.js';
import { initPopups } from './modules/popup.js';
import { initPopupSwitcher } from './modules/popup-switcher.js';
import { initDonationPopupSwitcher } from './modules/donation-popup-switcher.js';
import { initFormConditionals } from './modules/form-conditionals.js';
import { initFormErrorClearing } from './modules/form-error-clearing.js';
import { initProductListLoading } from './modules/product-list-loading.js';
import { initHeaderSearch } from './modules/header-search.js';
import { initProductQuantityTotal } from './modules/product-quantity-total.js';
import { initCartNoticeDrawer } from './modules/cart-notice-drawer.js';
import { initCartQuantityStepper } from './modules/cart-quantity-stepper.js';
import { initCartNotices } from './modules/cart-notices.js';

// Initialize headroom (runs immediately)
initHeadroom();

// Initialize modules that auto-init on load
initContactFormLabels();

// Initialize modules on DOM ready
document.addEventListener('DOMContentLoaded', () => {
	initSliders();
	initSideNav();
	initSidebarPullUp();
	initMegaMenu();
	initMobileMenu();
	initPostFilters();
	initPopups();
	initPopupSwitcher();
	initDonationPopupSwitcher();
	initFormConditionals();
	initFormErrorClearing();
	initProductListLoading();
	initHeaderSearch();
	initProductQuantityTotal();
	initCartNoticeDrawer();
	initCartQuantityStepper();
	initCartNotices();
});
